import uk from "../assets/images/flags/uk.png"
import spain from "../assets/images/flags/spain.jpg"
import germany from "../assets/images/flags/germany.jpg"
import italy from "../assets/images/flags/italy.jpg"
import french from "../assets/images/flags/french.jpg"
import netherlands from "../assets/images/flags/netherlands.png"


const languages = {
  en: {
    label: "English",
    flag: uk,
    tag: "en-US"
  },
  fr: {
    label: "French",
    flag: french,
    tag: "fr-FR"
  },
  de: {
    label: "German",
    flag: germany,
    tag: "de-DE"
  },
  it: {
    label: "Italian",
    flag: italy,
    tag: "it-IT"
  },
  nl: {
    label: "Dutch",
    flag: netherlands,
    tag: "nl-NL"
  },
  sp: {
    label: "Spanish",
    flag: spain,
    tag: "es-ES"
  }
}

export default languages
